<template>
    <div class="q-ma-sm q-gutter-y-sm" >
        <q-lins-filter-box :expanded="expand" @update="expand = !expand" 
            :aplicarBusca="buscarProduto" :limpar="limpaFiltro"
        >
            <template v-slot:filtros>
                <div class="justify-between items-end" :class="$q.screen.xs ? 'q-gutter-y-sm' : 'row'">
                    <q-input v-model="codBarras" label="Código Barras" square class="col q-pr-sm"
                        @keyup="() => {this.codBarras = this.codBarras.replace(/[^0-9]+/g, '')}"
                        @keyup.enter="buscarProduto">
                    </q-input>
                        <q-input v-model="codPaiLins" label="Código Pai Lins" @keyup.enter="buscarProduto" square
                            @keyup="() => {this.codPaiLins = this.codPaiLins.replace(/[^0-9]+/g, '')}"
                            class="col q-pl-sm"
                        >
                            <q-tooltip>
                                Código Pai Lins refere ao codigo antigo podendo ser buscado normalmente.
                            </q-tooltip>
                        </q-input>
                        <q-input v-model="codPai" label="Código Pai Senior" @keyup.enter="buscarProduto" square
                            @keyup="() => {this.codPai = this.codPai.replace(/[^0-9]+/g, '')}"
                            class="col q-pl-sm"
                        >
                            <q-tooltip>
                                Código Pai Senior refere ao codigo atual das etiquetas.
                            </q-tooltip>
                        </q-input>
                    </div>
            </template>
            <template v-slot:buttons>
                <q-space></q-space>
                <q-btn color="primary" class="q-ma-sm" push icon="search" @click="abrirModalProduto()">
                    <q-tooltip>Busca avançada por descrição/marca/familia</q-tooltip>
                    Busca Avançada
                </q-btn>

            </template>
        </q-lins-filter-box>

        <q-card v-if="produto.codFamilia">
            <q-card-section class="q-pb-xs">
                <p class="text-body1 text-left no-margin no-padding">Produto</p>
            </q-card-section>
            <q-card-section class="q-gutter-x-sm q-pt-xs" :class="$q.screen.xs ? 'q-gutter-y-sm' : 'row wrap'">
                <q-input class="col-2" v-model="produto.codFamilia" readonly filled label="Cod Familia" square/>
                <q-input class="col-2" v-model="produto.codProduto" v-if="produto.codProduto" readonly filled label="Cod Produto" square/>
                <q-input :class="produto.preco ? 'col-3' : 'col'" v-model="produto.descFamilia" readonly filled 
                    label="Descrição Familia" square/>
                <q-input class="col" v-model="produto.descProduto" v-if="produto.descProduto" readonly filled
                    label="Descrição Produto" square/>
                <q-input class="col-2" v-model="produto.preco" v-if="produto.preco" readonly filled label="Preço"
                    square/>
            </q-card-section>
        </q-card>
        <q-tabs-estoque v-if="listaLojas.length > 0" :produto="produto" :listaLojasEstoques="listaLojas" />
        <q-modal-busca-produtos-geral @buscaCodPai="$_atualizaCodPaiEmitidoBuscaAvancada" ref="refModalBuscaProduto"></q-modal-busca-produtos-geral>    
    </div>
</template>
  
<script>
import Router from '@/router/index.js'
import store from '@/store/index.js'
import MixinMessages from '@/mixins/mixinMessagens';
import QTabsEstoque from '@/components/QTabsEstoque.vue';
import QLinsFilterBox from '../../shared/QlinsFilterBox.vue';
import ConsultaEstoqueServices from '@/services/consulta_estoque'
import { ref } from 'vue';
import { useStore } from 'vuex';
import QModalBuscaProdutosGeral from '../../components/QModalBuscaProdutosGeral.vue';
export default {
    name: "ConsultaEstoque",

    mixins: [MixinMessages],

    components: { QTabsEstoque, QLinsFilterBox, QModalBuscaProdutosGeral },

    setup() {
        const store = useStore()
        const produto = ref({})
        const codPai = ref('')
        const codPaiLins = ref('')
        const codBarras = ref('')
        const listaLojas = ref([])
        const expand = ref(true)

        return {
            produto,
            codBarras,
            codPai,
            listaLojas,
            store,
            codPaiLins,
            expand
        }
    },
    methods: {
        async buscarProduto() {
            this.limpaDados()
            this.$_showLoading({ message: "Buscando estoque do produto" })
            let params = {}
            if(this.store.state.estabelecimento.lojaSelecionada.cod_filial == -1){
                this.errorMessage({
                    title: "Erro",
                    message: "Selecione o estabelecimento na tela inicial!"
                    }); 
                
                this.$_hideLoading()
                return
            }
            if (!this.codBarras && !this.codPai && !this.codPaiLins) {
                this.errorMessage({
                    title: "Erro",
                    message: "Por favor informe o codigo de barras ou codigo do produto"
                })
                this.$_hideLoading()
            } else {
                this.$_showLoading({ message: "Buscando estoque do produto" })
                this.codPai ? params.cod_pai_senior = this.codPai : ''
                this.codPaiLins ? params.cod_pai_lins = this.codPaiLins : ''
                this.codBarras ? params.cod_barras = this.codBarras : ''
                ConsultaEstoqueServices.buscarEstoqueCompleto(params)
                    .then(async (resposta) => {
                        const produtos = resposta
                        if(produtos.length > 0){
                            this.formataProdutos(produtos)
                        }
                        else {
                            this.warningMessage({
                            title: "Atenção",
                            message: "Não foi encontrado produtos para esta pesquisa."
                        })
                        }
                        this.$_hideLoading()
                    }).catch(erro => {
                        if (erro.response.data.code == "token_not_valid"){
                            this.errorMessage({
                                title: "Erro",
                                message: "Sessão expirada!"
                            })

                            store.commit('logout')
                            store.commit('limpaEstabelecimentos')
                            Router.push('/login')

                            localStorage.setItem("jwtToken", "")
                            localStorage.setItem("recaptchaToken", "")
                        }
                        else{

                            this.errorMessage({
                                title: "Erro",
                                message: "Não foi possivel realizar a busca, tente novamente!"
                            })
                        }
                        console.log(erro)
                        this.$_hideLoading()
                    })

            }
        },
        formataProdutos(produtos) {
            this.expand = false
            this.$_showLoading({ message: "Buscando estoque do produto" })
            let loja = {
                nome: this.store.state.estabelecimento.lojaSelecionada.nome_filial,
                total: 0,
                condicional: 0,
                em_loja: 0,
                em_transito: 0,
                total_reserva: 0,
                produtos: [],
            }
            let produtoFormatadoPromise = produtos.reverse().map((produto, index) => {
                this.produto.codFamilia = produto.cod_familia
                this.produto.descFamilia = produto.desc_familia
                this.produto.codAgpComercial = produto.cod_agrup_comercial
                this.produto.descAgpComercial = produto.desc_agrup_comercial
                this.produto.marca = produto.marca
                this.produto.codAgpEstoque = produto.cod_agp_estoque
                this.produto.descAgpEstoque = produto.desc_agp_estoque
                this.produto.urlsImagens = produto.urls_imagens
                localStorage.setItem('api_vtex_error', produto.erro_vtex_api);
                produto.em_transito = 0
                produto.est_condicional = 0
                produto.qtd_loja = 0
                produto.total = 0
                produto.em_loja = 0
                produto.total_reservado = 0
                produto.tamanhos.map((tamanho) => {
                    // Calcula os estoques da variacao do produto e a adiciona o preco no respectivo produto
                    produto.total = parseInt(produto.total) + parseInt(produto.qtd_loja) + parseInt(tamanho.qtd_loja) + parseInt(tamanho.reservado) + parseInt(tamanho.est_condicional)
                    produto.em_transito = parseInt(produto.em_transito) + parseInt(tamanho.est_transito)
                    produto.est_condicional = parseInt(produto.est_condicional) + parseInt(tamanho.est_condicional)
                    produto.em_loja = parseInt(produto.qtd_loja) + parseInt(tamanho.qtd_loja) + parseInt(produto.em_loja)
                    produto.total_reservado = parseInt(produto.total_reservado) + parseInt(tamanho.reservado)
                })
                // Calcula os totalizadores do produto em loja
                loja.total = parseInt(loja.total) + parseInt(produto.em_loja) + parseInt(produto.est_condicional) + parseInt(produto.total_reservado)
                loja.em_loja = parseInt(loja.em_loja) + parseInt(produto.em_loja)
                loja.condicional = parseInt(loja.condicional) + parseInt(produto.est_condicional)
                loja.em_transito = parseInt(loja.em_transito) + parseInt(produto.em_transito)
                loja.total_reserva = parseInt(produto.total_reservado) + parseInt(loja.total_reserva)
                if (this.codBarras) {
                    // Se a busca for por cod_barras o produto tem informaçoes completas, pra isso é feito uma busca
                    // nas variacoes para descobrir qual foi o produto selecionado e pegar estas informacoes
                    if (produto.tamanhos.some(tamanho => tamanho.cod_barras == this.codBarras)) {
                        produto.expand = true
                        this.produto.descProduto = produtos[index].desc_produto
                        let tamanho = produto.tamanhos.filter((tamanho => tamanho.cod_barras == this.codBarras))
                        this.produto.preco = 'R$' + parseFloat(tamanho[0].preco).toFixed(2).replace('.',',')
                        this.produto.codProduto = produtos[index].cod_produto
                    }
                }
                return produto
            })

            Promise.all(produtoFormatadoPromise).then(produtoFormatado => {
                loja.produtos = produtoFormatado
                this.listaLojas.push({ expand:true, loja })
                this.$_hideLoading()
            })
        },

        abrirModalProduto(){
            this.$refs.refModalBuscaProduto.show()
        },

        $_showLoading(options) {
            this.$q.loading.show(options)
        },

        $_hideLoading() {
            this.$q.loading.hide()
        },

        $_atualizaCodPaiEmitidoBuscaAvancada(value){
            this.$refs.refModalBuscaProduto.hide()
            this.codPai = value
            this.buscarProduto()
        },

        limpaDados(){
            this.listaLojas = []
            this.produto = {
                codFamilia: '',
                codProduto: '',
                descFamilia: '',
                descProduto: '',
                codAgpComercial: '',
                descAgpComercial: '',
                codAgpEstoque: '',
                descAgpEstoque: '',
                marca: '',
                preco: '',
            }
        },

        limpaFiltro(){
            this.codPai = ''
            this.codPaiLins = ''
            this.codBarras = ''
        }
    }
};
</script>